import { Skeleton } from '@web/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@web/components/ui/card';
export default function ContactSkeleton() {
  return (
    <Card className="mt-4">
      <CardHeader>
        <Skeleton className="h-8 w-3/4" />
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          {/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */}
          {[...Array(7)].map((_, i) => (
            <Skeleton key={i} className="h-6 w-full" />
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
